import { render, staticRenderFns } from "./BasePopUpCard.vue?vue&type=template&id=b3ceeace"
import script from "./BasePopUpCard.vue?vue&type=script&lang=js"
export * from "./BasePopUpCard.vue?vue&type=script&lang=js"
import style0 from "./BasePopUpCard.vue?vue&type=style&index=0&id=b3ceeace&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports